import { useRef, useState } from 'react';
import * as React from 'react';
import TextField from '../TextField/TextField';
import styles from './Search.module.css';
import useTranslation from '../../../../Hooks/useTranslation';

interface Props {
	resultContent?: React.ReactNode;
	handleSearch: (text: string) => void;
	placeholder?: string;
	marginTop?: number | undefined;
	label?: string | null;
}

const Search: React.FC<Props> = ({
	resultContent,
	handleSearch,
	placeholder,
	marginTop = undefined,
	label = null,
}) => {
	const inputRef = useRef(null);
	const { t } = useTranslation();

	return (
		<div
			className='search-user search-user-toggleable'
			style={{ marginTop: marginTop }}
		>
			<div>
				<div className={styles.searchWrapper}>
					{label && (
						<div className={'col-form-label'}>
							<label>{label}</label>
						</div>
					)}
					<TextField
						ref={inputRef}
						onChange={handleSearch}
						placeholder={t(placeholder)}
						className={styles.searchInput}
						wrapperClassName={styles.textWrapper}
						bounce={350}
						selfValue
					/>
				</div>
				{resultContent}
			</div>
		</div>
	);
};

export default Search;
